import { Injectable } from '@angular/core';
import { NavLink } from '@rd/types';
import { UrlUtilsService } from '../url-utils/url-utils.service';

@Injectable({
  providedIn: 'root',
})
export class NavLinksService {
  allNavLinks: NavLink[];
  logoutNavLink: NavLink;

  constructor(private urlUtilsService: UrlUtilsService) {
    this.allNavLinks = this.setAllNavLinks();
    this.logoutNavLink = this.setLogoutNavLink();
  }

  private setAllNavLinks(): NavLink[] {
    return [
      {
        translationKey: 'header.points_transaction',
        iconUrl: this.urlUtilsService.imageUrl(
          '/images/rd-points-transaction-icon.png',
        ),
        route: '/points_activity',
      },
      {
        translationKey: 'header.my_travel_bookings',
        iconUrl: this.urlUtilsService.imageUrl(
          '/images/rd-travel-booking-icon.png',
        ),
        route: this.urlUtilsService
          .travelEdgeUrl('/account/booking')
          .toString(),
      },
      {
        translationKey: 'header.account_settings',
        iconUrl: this.urlUtilsService.imageUrl('/images/rd-myprofile-icon.png'),
        route: this.urlUtilsService
          .travelEdgeUrl('/account/profile')
          .toString(),
      },
    ];
  }

  private setLogoutNavLink(): NavLink {
    return {
      translationKey: 'header.log_out',
      iconUrl: this.urlUtilsService.imageUrl('/images/rd-myprofile-icon.png'),
      // TODO: TS-strict-mode fix it later
      // @ts-ignore
      route: null,
    };
  }
}
